class WebFontFile extends Phaser.Loader.File {
    constructor(loader: Phaser.Loader.LoaderPlugin, fileConfig: Phaser.Types.Loader.FileConfig) {
        super(loader, fileConfig);
    }
    load() {
        if (this.state == Phaser.Loader.FILE_POPULATED) {
            this.loader.nextFile(this,true);
            return;
        }
        let a = new FontFace(this.key,"url(" + this.url +")");
        document.fonts.add(a);

        a.load().then(() => {
            this.loader.nextFile(this,true);
        },
        () => {
            this.loader.nextFile(this,false);
        });
     
    }
}

let loaderCallback = function(key, config) {
    config = {
        key : key,
        type : "webfont",
        url : config,
        config : config
    };
    this.addFile(new WebFontFile(this,config));
    return this;
}

export default class WebFontLoaderPlugin extends Phaser.Plugins.BasePlugin {
    constructor(pluginManager: Phaser.Plugins.PluginManager) {
        super(pluginManager);
        pluginManager.registerFileType("webfont",loaderCallback);
    }
    addToScene(scene) {
        scene.sys.load["webfont"] = loaderCallback;
    }
}